import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./RecipesIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./RecipesList'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./RecipesFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const RecipeRunsList = Loadable({
  loader: () => import('./RecipeRunsList'),
  loading: () => <Loading withContentWrapper />,
});
